// import { buyerAddressFields } from "../formFields.js/PurchaseOrderFields";
// import GenericFormTabPo from "./GenericFormTabPo";

// export default function BuyerAddressTab({ formData, onChange, readOnly = false }) {
//   return <GenericFormTabPo fields={buyerAddressFields} formData={formData} onChange={onChange} readOnly={readOnly} />;
// }









import { supplierAddressFields, buyerAddressFields } from "../formFields.js/PurchaseOrderFields";
import GenericFormTabPo from "./GenericFormTabPo";
import { useState } from "react";

export default function BuyerAddressTab({ formData, onChange, readOnly = false, formSubmissionAttempted }) {
  const [activeTab, setActiveTab] = useState("supplier"); // default active tab

  return (
    <div>
      {/* Tabs Header */}
      <ul className="nav nav-pills mb-3 gap-1 bg-light p-1 rounded shadow-sm">
        <li className="nav-item">
          <button
            className={`nav-link d-flex align-items-center px-4 py-1 fw-semibold ${activeTab === "supplier" ? "active btn-primary text-white" : "text-dark"
              }`}
            onClick={() => setActiveTab("supplier")}
          >
            <i className="bi bi-box-seam me-2"></i> Source / Supplier
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link d-flex align-items-center px-4 py-1 fw-semibold ${activeTab === "buyer" ? "active btn-primary text-white" : "text-dark"
              }`}
            onClick={() => setActiveTab("buyer")}
          >
            <i className="bi bi-person-lines-fill me-2"></i> Destination / Buyer
          </button>
        </li>
      </ul>


      {/* Tabs Content */}
      <div className="tab-content  rounded p-3">
        {activeTab === "supplier" && (
          <div className="tab-pane fade show active">
            <GenericFormTabPo
              fields={supplierAddressFields}
              formData={formData}
              onChange={onChange}
              readOnly={readOnly}
              formSubmissionAttempted={formSubmissionAttempted}
            />
          </div>
        )}

        {activeTab === "buyer" && (
          <div className="tab-pane fade show active">
            <GenericFormTabPo
              fields={buyerAddressFields}
              formData={formData}
              onChange={onChange}
              readOnly={readOnly}
              formSubmissionAttempted={formSubmissionAttempted}
            />
          </div>
        )}
      </div>
    </div>
  );
}
